<template>
  <v-dialog v-model="showDialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="headline info white--text">
        <v-icon color="white" class="mr-2">mdi-truck-fast</v-icon>
        We've Moved
      </v-card-title>

      <v-card-text class="pt-5 text-center">
        <p class="text-body-1 mb-2">This site has been moved to</p>

        <a
          href="https://kids.hamochi.my"
          class="d-block text-h4 font-weight-bold blue--text text--darken-2 text-decoration-none my-4"
          style="word-break: break-all; line-height: 1.2"
        >
          kids.hamochi.my
        </a>

        <v-divider class="my-4"></v-divider>

        <p class="text-body-2 mb-2">
          All users must register a new account at
          <a href="https://math.hamochi.my" class="blue--text">math.hamochi.my</a>.
        </p>

        <v-btn
          block
          color="info"
          dark
          large
          rounded
          href="https://math.hamochi.my"
          class="my-3"
        >
          Register on New Site
        </v-btn>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dismiss">Dismiss</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    showDialog: false,
  }),
  mounted() {
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem("siteMovedDialogDismissedDate") !== today) {
      this.showDialog = true;
    }
  },
  methods: {
    dismiss() {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem("siteMovedDialogDismissedDate", today);
      this.showDialog = false;
    },
  },
};
</script>
